exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-container-1jDtg{display:flex;align-items:center;column-gap:7px;font-size:13px;color:var(--color);font-weight:500;line-height:1;--color:var(--color-night-gray8,#32435e)}.style-cssmodule-container-1jDtg[data-status=IN_PROGRESS],.style-cssmodule-container-1jDtg[data-status=STARTED]{--color:var(--color-green-normal,#4eb479)}.style-cssmodule-container-1jDtg[data-status=CREATED]{--color:var(--color-blue-normal,#1552d7)}.style-cssmodule-container-1jDtg[data-status=IN_OVERSTAY]{--color:var(--color-orange-normal,#f77706)}.style-cssmodule-container-1jDtg[data-status=FINISHED]{--color:var(--color-blue-dark,#04249c)}.style-cssmodule-container-1jDtg[data-status=CANCELLED]{--color:var(--color-red-middle,#d32f2f)}.style-cssmodule-iconContainer-3nHqC{width:14px;height:14px;display:grid;place-items:center}", ""]);

// exports
exports.locals = {
	"container": "style-cssmodule-container-1jDtg",
	"iconContainer": "style-cssmodule-iconContainer-3nHqC"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/parkings/components/Status/style.cssmodule.css
// module id = 2564
// module chunks = 121